import React from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Box,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { axiosConfig } from "../../../../../axios/axiosConfig";

const headCellSx = {
  fontWeight: 700,
  fontSize: "12px",
  color: "#fff",
  background: "#04343a",
  borderBottom: "none",
  padding: "10px 14px",
  whiteSpace: "nowrap",
};

const BannerImageTable = ({ bannerImagesList, setBannerImagesList }) => {
  const deleteBannerMutation = useMutation({
    mutationFn: async (banner_id) => {
      const res = await axiosConfig({
        method: "delete",
        url: "/home/banner",
        data: { id: banner_id },
      });
      return res.data;
    },
    onSuccess: (data, banner_id) => {
      setBannerImagesList((currBannerList) =>
        currBannerList.filter((item) => item.id !== banner_id)
      );
      alert(data?.response);
    },
    onError: (error) => {
      toast.error(error?.response?.data?.response || "Something went wrong");
    },
  });

  const handleDeleteBanner = (BannerID) => {
    if (!window.confirm("Are you sure you want to delete this image?")) return;
    deleteBannerMutation.mutate(BannerID);
  };

  return (
    <Box
      sx={{
        background: "#fff",
        borderRadius: "12px",
        border: "1px solid #e2e8f0",
        boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
        overflow: "hidden",
        mb: 3,
      }}
    >
      {/* Section header */}
      <Box sx={{ background: "#04343a", px: "20px", py: "12px" }}>
        <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: "15px" }}>
          Banner Image Table
        </Typography>
      </Box>

      <TableContainer component={Paper} elevation={0} sx={{ borderTop: "1px solid #eef2f7", overflowX: "auto" }}>
        <Table
          size="small"
          sx={{
            minWidth: 700,
            "& .MuiTableCell-root": {
              padding: "9px 14px",
              fontSize: "12px",
              borderBottom: "1px solid #f0f4f8",
              whiteSpace: "nowrap",
            },
            "& .MuiTableBody-root .MuiTableRow-root:hover": {
              background: "#f0faf5",
            },
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell sx={{ ...headCellSx, width: 55 }}>Sr. No.</TableCell>
              <TableCell sx={{ ...headCellSx, minWidth: 200 }}>Image Link</TableCell>
              <TableCell sx={{ ...headCellSx, minWidth: 180 }}>URL</TableCell>
              <TableCell sx={{ ...headCellSx, width: 80 }}>Preview</TableCell>
              <TableCell sx={{ ...headCellSx, width: 130 }}>Screen Name</TableCell>
              <TableCell sx={{ ...headCellSx, width: 80 }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!bannerImagesList?.length ? (
              <TableRow>
                <TableCell colSpan={6} align="center" sx={{ py: 5, color: "#94a3b8", fontSize: "13px" }}>
                  No banner images found.
                </TableCell>
              </TableRow>
            ) : (
              bannerImagesList.map((item, index) => {
                const imgPreview = item?.image ? item?.image : item?.redirect_url;
                return (
                  <TableRow key={item.id}>
                    <TableCell sx={{ color: "#94a3b8" }}>{index + 1}</TableCell>
                    <TableCell sx={{ color: "#64748b", maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis" }}>
                      {item?.image}
                    </TableCell>
                    <TableCell sx={{ color: "#64748b", maxWidth: 180, overflow: "hidden", textOverflow: "ellipsis" }}>
                      {item?.redirect_url}
                    </TableCell>
                    <TableCell>
                      <Tooltip
                        title={<img src={imgPreview} alt="Banner Preview" style={{ width: 200 }} />}
                        placement="top"
                      >
                        <IconButton size="small" sx={{ color: "#016551", "&:hover": { bgcolor: "#e6f4f1" } }}>
                          <VisibilityIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                    <TableCell sx={{ color: "#64748b" }}>{item?.screen_name}</TableCell>
                    <TableCell>
                      <Tooltip title="Delete" arrow>
                        <IconButton
                          size="small"
                          onClick={() => handleDeleteBanner(item?.id)}
                          sx={{ color: "#b91c1c", "&:hover": { bgcolor: "#fee2e2" } }}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default BannerImageTable;
